import { CircularProgress } from '@mui/material'
import { tss } from 'tss-react/mui'
import { ButtonSize, ButtonVariant } from '../../button/types'
import { LoadingSpinnerProps } from '../types'
import { getButtonLoadingSpinnerColor, getButtonLoadingSpinnerSize } from './primitives'

export interface ButtonLoadingSpinnerProps extends Omit<LoadingSpinnerProps, 'type' | 'classes'> {
  buttonVariant?: ButtonVariant
  buttonSize?: ButtonSize
  position?: 'absolute' | 'relative'
  classes?: Partial<ReturnType<typeof useStyles>['classes']>
}

const useStyles = tss
  .withParams<{
    buttonVariant: ButtonVariant
    position: 'absolute' | 'relative'
  }>()
  .create(({ buttonVariant, position }) => ({
    root: {
      position,
      ...getButtonLoadingSpinnerColor(buttonVariant),
      animationDuration: '650ms',
      zIndex: 9,
      left: '0',
      right: '0',
      top: '0',
      bottom: '0',
      margin: 'auto',
    },
  }))

export const ButtonLoadingSpinner = ({
  buttonVariant,
  buttonSize,
  position,
  ...rest
}: ButtonLoadingSpinnerProps) => {
  const { classes } = useStyles({
    classesOverrides: rest.classes,
    buttonVariant: buttonVariant ?? 'primary',
    position: position ?? 'absolute',
  })

  return (
    <CircularProgress
      className={classes.root}
      disableShrink
      size={getButtonLoadingSpinnerSize(buttonSize ?? 'medium')}
      {...rest}
    />
  )
}
